(function ($) {
  DJ.addBehavior('userPictureUpload', {
    /**
     * Custom DJ method. Can be called where needed like this:
     * DJ.behaviors.userPictureUpload.userPictureUploadInit();
     * Allows to choose, crop and upload image.
     */

    userPictureUploadInit: () => {
      let $uploadCrop;
      const $componentHolder = $('.user-picture-upload');
      const $popupHolder = $('.user-picture-upload__popup');
      const $crop = $('.user-picture-upload__crop', $popupHolder);
      const $btnFile = $('.user-picture-upload__btn-file input', $popupHolder);
      const $btnUpload = $('.user-picture-upload__btn-upload', $popupHolder);
      const $userImage = $('.user-picture-upload .user-picture-upload__img img');
      const $uploadDataField = $('input.js-picture-base64-upload-element');

      /**
       * Read data from upload input and bind to croppie.
       * @param input
       *    file input.
       */
      const readFile = (input) => {
        const fileTypes = ['jpg', 'jpeg', 'png'];

        if (input.files && input.files[0]) {
          const reader = new FileReader();
          const file = input.files[0];
          const fileExt = file.type.split('/')[1];

          if (fileTypes.indexOf(fileExt) !== -1) {
            reader.onload = function (e) {
              $popupHolder.addClass('user-picture-upload__popup--ready');
              $popupHolder.removeClass('user-picture-upload__popup--error');
              $uploadCrop.croppie('bind', {
                url: e.target.result
              });
            };

            reader.readAsDataURL(file);
          } else {
            $popupHolder.removeClass('user-picture-upload__popup--ready');
            $popupHolder.addClass('user-picture-upload__popup--error');
          }
        }
      };

      /**
       * Init croppie lib.
       * @type {jQuery}
       */
      $uploadCrop = $crop.croppie({
        viewport: {
          width: 270,
          height: 270,
        },
        enableExif: true
      });

      /**
       * Bind readFile on file input change.
       */
      $btnFile.on('change', function () { readFile(this); });

      /**
       * Transfer cropped result to show/save/etc.
       */
      $btnUpload.on('click', function () {
        $uploadCrop.croppie('result', {
          type: 'canvas',
          size: 'viewport',
          format: 'jpeg'
        }).then(function (resp) {
          $userImage.attr('src', resp);
          $uploadDataField.val(resp);
          $componentHolder.addClass('user-picture-upload--ready');
          $('.cems-modal__close').trigger('click');
        });
      });
    }
  });
})(jQuery);
